import {
    Box,
    FormHelperText,
    Grid,
    InputLabel,
    Typography,
} from '@mui/material';
import React from 'react';
import FormCheckbox from '../../../shared/FormCheckbox';
import FormCounter from '../../../shared/FormCounter';
import FormSwitch from '../../../shared/FormSwitch';

const LivingRoomForm = ({ control }: { control: any }) => {
    return (
        <Grid>
            <Grid item xs={12}>
                <Typography
                    component='h2'
                    variant='h3'
                    color='text.primary'
                    sx={{ mb: 0.25 }}
                >
                    Sleeping arrangements
                </Typography>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Single bed</InputLabel>
                    <FormCounter name='singleBed' disabled={false} />
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Double bed</InputLabel>
                    <FormCounter name='doubleBed' disabled={false} />
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Queen bed</InputLabel>
                    <FormCounter name='queenBed' disabled={false} />
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>King bed</InputLabel>
                    <FormCounter name='kingBed' disabled={false} />
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Bunk bed</InputLabel>
                    <FormCounter name='bunkBed' disabled={false} />
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Sofa bed</InputLabel>
                    <FormCounter name='sofaBed' disabled={false} />
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Couch</InputLabel>
                    <FormCounter name='couch' disabled={false} />
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel>Baby cot</InputLabel>
                    <FormCounter name='babyCot' disabled={false} />
                </Grid>
            </Grid>{' '}
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid item container xs={12} md={6}>
                    <Grid item xs={12} sx={{ pt: 2 }}>
                        <Typography
                            component='h2'
                            variant='h3'
                            color='text.primary'
                            sx={{ mb: 0.25 }}
                        >
                            Amenities
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        name='poolTable'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel>Pool Table</InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        name='wardrobe'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel>Wardrobe</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        name='extraPillowsAndBlankets'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel>Extra Pillows and Blankets</InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox name='iron' control={control} sx={{ p: 0 }} />
                    <InputLabel>Iron</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox name='safe' control={control} sx={{ p: 0 }} />
                    <InputLabel>Safe</InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox name='tv' control={control} sx={{ p: 0 }} />
                    <InputLabel>Tv</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        name='fireplace'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel>Fireplace</InputLabel>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LivingRoomForm;
